import {
  FETCH_CLAIM_ACCOUNTS_BEGIN,
  FETCH_CLAIM_ACCOUNTS_SUCCESS,
  FETCH_CLAIM_ACCOUNTS_ERROR,
  FETCH_CLAIM_BENEFIT_PLANS_BEGIN,
  FETCH_CLAIM_BENEFIT_PLANS_SUCCESS,
  FETCH_CLAIM_BENEFIT_PLANS_ERROR,
} from "actions/claimAccountsActions";

const initialState = {
  benefitPlans: [],
  accounts: [],
  uiConfigs: null,
  isFetching: false,
  error: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_CLAIM_ACCOUNTS_BEGIN: {
      return {
        ...state,
        accounts: [],
        uiConfigs: null,
        isFetching: true,
      };
    }

    case FETCH_CLAIM_ACCOUNTS_SUCCESS: {
      return {
        ...state,
        accounts: action.payload.accountList.accountDtos,
        uiConfigs: action.payload.uiConfigs,
        isFetching: false,
        error: null,
      };
    }
    case FETCH_CLAIM_BENEFIT_PLANS_ERROR:
    case FETCH_CLAIM_ACCOUNTS_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    case FETCH_CLAIM_BENEFIT_PLANS_BEGIN:
      return {
        ...state,
        benefitPlans: [],
        isFetching: true,
      };
    case FETCH_CLAIM_BENEFIT_PLANS_SUCCESS:
      return {
        ...state,
        benefitPlans: action.payload,
        isFetching: true,
        error: null,
      };
    default: {
      return { ...state, deleteClaim: { status: false } };
    }
  }
};



// WEBPACK FOOTER //
// ./reducers/claimAccountsReducer.js